module.exports = __webpack_public_path__ + "media/images/up-96b4ba38.png";